import React from 'react';

function CardBody({ children, className, style = {}}) {
  return (
    <div className={`p-2 ${className}`} style={style}>
      { children }
    </div>
  );
}

export default CardBody;
